<template>
    <div>
        
        <el-form @submit.native.prevent="onSubmitMatriculaAee" :model="dados" ref="dados" label-position="top">
            
            <el-row :gutter="10">
                <el-col :xs="24" :sm="18" :md="18">
                    
                    <template v-if="$store.state.user.tipo > 3 && $store.state.user.tipo <= 8">
                        <el-form-item label="Instituição" prop="instituicao_id" :rules="[$requiredChange]" key="instituicao_id">
                            <el-select @change="changeInstituicao()" v-model="dados.instituicao_id" filterable>
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </template>

                    <template v-if="$store.state.user.tipo <= 3 || $store.state.user.tipo >= 9">
                        <el-form-item label="Instituição">
                            <el-input readonly v-model="$store.state.config.instituicao.nome" maxlength="191" class="readonly"></el-input>
                        </el-form-item>
                    </template>

                </el-col>
                <el-col :xs="24" :sm="6" :md="6">
                    <el-form-item label="Período" prop="periodo.nome" :rules="[$requiredChange]" key="periodo">
                        <el-input readonly v-model="dados['periodo']['nome']" maxlength="191" class="readonly"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Aluno" prop="aluno" key="aluno">
                        <el-input readonly v-model="dados['aluno']['nome']" maxlength="191" class="readonly"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item label="Turma" prop="turma" :rules="[$requiredChange]" key="turma">
                        <el-select v-model="dados['turma']" @change="changeTurma()">
                            <el-option v-for="(turma, i) in turmas" :key="i" :label="turma['vagas_disponiveis']" :value="turma['id']"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <div class="u-text-right">
                            <el-button :loading="loading" type="primary" native-type="submit">MATRICULAR</el-button>
                        </div>
                    </el-col>
                </el-row>
        </el-form>
       
    </div>
</template>
<script>

export default {
    // complementar: matrícula em turma de atividade complementar (mesmo formulário da AEE).
    props: { aluno: Object, complementar: { type: Boolean, default: false } },
    data: () => ({
        loading: false,
        dados:{
            aluno: { id: '', nome: '', data_nascimento: '' },
            instituicao_id: '',
            periodo: '',
            turma: ''
        },
        turmas: []
    }),
    created(){  },
    methods:{
        getTurmasAee(){

            const rota = this.complementar ? 'getAllTurmasAtividadeComplementar' : 'getAllTurmasAee';

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/${rota}/${this.dados.instituicao_id}/${this.dados.periodo.id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.turmas = response.data;
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        changeInstituicao(){

            this.getTurmasAee();
        },
        changeTurma(){
        //QUANDO UMA TURMA É SELECIONADA

            for(let i in this.turmas){

                if(this.turmas[i].id == this.dados.turma && this.turmas[i].matriculas.length >= this.turmas[i].qtd_vagas){

                    this.dados.turma = '';
                    window.eventBus.$emit('alert', {msg: 'A turma selecionada não possui vagas disponíveis.', type: 'warning'});
                }
            }
        },
        onSubmitMatriculaAee(){

            this.$refs.dados.validate((valid) =>{ if(valid){

                this.loading = true;
                window.eventBus.$emit('loading', true);

                const rota = this.complementar ? 'novaMatriculaAtividadeComplementar' : 'novaMatriculaAee';

                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/matricula/${rota}`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                    /*
                        O backend recusa a operação devolvendo `{ erro: '...' }` — é assim que
                        o bloqueio de capacidade da turma e o de documentos obrigatórios
                        respondem. Sem este teste, a recusa caía no ramo de sucesso e a tela
                        anunciava "Matrícula realizada com Sucesso" sem ter matriculado ninguém.
                    */
                    if (response.data && response.data.erro) {
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', { msg: response.data.erro, type: 'error' });
                        return;
                    }

                
                    if(typeof response.data.throw !== 'undefined'){

                        window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                    }else{
                        
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        // Como o requerimento na matrícula regular: já abre a Ficha de Inscrição do CIM.
                        if (response.data && response.data.matricula_id) {
                            window.eventBus.$emit('print', {url: '/api/pdf/renderAtestadoAluno/ficha-inscricao', param: response.data.matricula_id});
                        }

                        this.$emit('onSubmitMatriculaAee');
                    }   
                    
                    this.loading = false;
                    window.eventBus.$emit('loading', false);

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });


            }else{
                
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});

        }
        
    },
    watch: {
        aluno: {
            immediate: true,
            handler (value) {
                
                if(value){

                    this.dados.aluno = JSON.parse(JSON.stringify(value));

                    this.dados.periodo = JSON.parse(JSON.stringify(this.$store.state.config.periodo));   

                    if(this.$store.state.config.instituicao.id){
                        
                        this.dados.instituicao_id = JSON.parse(JSON.stringify(this.$store.state.config.instituicao.id));

                        this.getTurmasAee();
                    }
                                     
                } 
            }
        }     
    },
    components:{  }
}
</script>
